export enum KYCStatusCodes {
  Submitted = 2,
  Canceled = 3,
  SubmittedWithWarnings = 4,
  Rejected = 5,
  Expired = 6,
  NotStarted = 9
}
